import EventBus from "@plugins/common/service/eventbus";

const PageDrawerEventBus = new EventBus();

export default PageDrawerEventBus;
